// React
import { useEffect, useReducer, useState } from "react";
import PropTypes from "prop-types";

// MUI
import { Typography, Grid } from "@mui/material";

// Components
import InputFormExtension from "@/Layouts/components/InputComponents/InputFormExtension";
import CustomizedSwitches from "@/Layouts/components/InputComponents/CustomizedSwitches";

const initialState = {
	miniDeal: {
		value: 0,
		input: "Dollar",
		variant: "standard",
	},
	cap: {
		value: 0,
		input: "Dollar",
		variant: "standard",
	},
	capEnabled: false,
};

const reducer = (state, action) => {
	switch (action.type) {
		case "UPDATE_MINI_DEAL":
			return {
				...state,
				miniDeal: {
					value: action?.payload?.value || 0,
					input: action?.payload?.type || "Dollar",
					variant: action?.payload?.variant || "error",
				},
			};
		case "UPDATE_CAP":
			return {
				...state,
				cap: {
					value: action?.payload?.value || 0,
					input: action?.payload?.type || "Dollar",
					variant: action?.payload?.variant || "error",
				},
			};
		case "UPDATE_CAP_SWITCH":
			return {
				...state,
				capEnabled: action?.payload,
			};
		default:
			break;
	}
	return state;
};

export default function MiniDealCommissions(props) {
	const { model = null, readOnly = false } = props;
	const [state, dispatch] = useReducer(reducer, initialState);
	const [checked, setChecked] = useState(false);

	const handleOnActionMiniDealUpdate = (value, type) => {
		dispatch({ type: "UPDATE_MINI_DEAL", payload: { value, input: type, variant: "standard" } });
		if (props.onActionMiniUpdate) {
			props.onActionMiniUpdate({ value, input: type });
		}
	};

	const handleOnActionCapUpdate = (value, type) => {
		dispatch({ type: "UPDATE_CAP", payload: { value, input: type, variant: "standard" } });
		if (props.onActionCapUpdate) {
			props.onActionCapUpdate({ value, input: type });
		}
	};

	const handleUpdateCapSwitch = (value) => {
		dispatch({ type: "UPDATE_CAP_SWITCH", payload: value });
		setChecked(!checked);

		if (!value) {
			dispatch({ type: "UPDATE_CAP", payload: { value: 0, input: "Dollar", variant: "standard" } });
			props.onActionCapUpdate({ value: 0, input: "Dollar" });
		}
	};

	useEffect(() => {
		const { cap = { input: "Dollar", value: 0 }, mini = { input: "Dollar", value: 0 } } = model || {};

		if (props?.model) {
			setChecked(Boolean(cap.value));

			if (cap.value) {
				dispatch({
					type: "UPDATE_CAP",
					payload: { value: cap?.value, input: props?.model?.cap?.input || "Dollar", variant: "standard" },
				});
			}

			if (mini.value) {
				dispatch({
					type: "UPDATE_MINI_DEAL",
					payload: { value: mini?.value, input: mini?.input || "Dollar", variant: "standard" },
				});
			}
		}
		return () => {};
	}, [model]);

	return (
		<Grid container rowSpacing={2} mb={4} className={"model-tiered-container"}>
			<Grid item xs={6} sx={{ marginTop: "16px" }} className="!mb-[10px]">
				<Grid container direction={"row"}>
					<Grid item>
						<Typography variant="h5" component="div" className={"tiered-title text-center !mb-[6px]"}>
							{"Mini-Deal"}
						</Typography>
						<Grid>
							<InputFormExtension
								data={[
									{
										type: "Dollar",
										min: 0,
										max: 10000,
										decimalsEditable: true,
										decimals: 2,
									},
								]}
								defaultType={state?.miniDeal?.type || "Dollar"}
								value={state?.miniDeal?.value || 0}
								sx={{ width: "80px" }}
								variant={state?.miniDeal?.variant || "standard"}
								onActionUpdate={(value, type) => handleOnActionMiniDealUpdate(value, type)}
								onFocusOut={props.onFocusOut}
							/>
						</Grid>
					</Grid>
					<Grid sx={{ m: 2 }}></Grid>
					<Grid item>
						<Typography variant="h5" component="div" className={"tiered-title text-center !mb-[6px]"}>
							{"Cap"}
						</Typography>
						<Grid>
							<InputFormExtension
								data={[
									{
										type: "Dollar",
										min: 0,
										max: 10000,
										decimalsEditable: true,
										decimals: 2,
									},
								]}
								defaultType={"Dollar"}
								value={state?.cap?.value || 0}
								sx={{ width: "80px" }}
								variant={state?.cap?.variant || "standard"}
								onActionUpdate={(value, type) => handleOnActionCapUpdate(value, type)}
								readOnly={readOnly || !checked}
								onFocusOut={props.onFocusOut}
							/>
						</Grid>
					</Grid>
					<Grid sx={{ m: 0.5 }}></Grid>
					<Grid container sx={{ width: "150px", paddingTop: "27px" }}>
						<CustomizedSwitches
							textRight
							textChecked="Enable Cap"
							textUnChecked="Enable Cap"
							checked={checked}
							disabled={readOnly}
							onChange={(val) => handleUpdateCapSwitch(val)}
						/>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
}

MiniDealCommissions.propTypes = {
	onActionMiniUpdate: PropTypes.func,
	onActionCapUpdate: PropTypes.func,
	onFocusOut: PropTypes.func,
	readOnly: PropTypes.bool,
	model: PropTypes.shape({
		capEnabled: PropTypes.bool,
		cap: PropTypes.shape({
			value: PropTypes.number,
			input: PropTypes.string,
		}),
		mini: PropTypes.shape({
			value: PropTypes.number,
			input: PropTypes.string,
		}),
	}),
};
